import request from '../request';

type RequestBody = {
  idToken: string;
};

type Response = {
  accountId: string;
}[];

const getAccount = async (body: RequestBody) => {
  const result = await request<Response>({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/accounts`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${body?.idToken}`,
    },
  });

  return { accountId: result.pop()?.accountId };
};

export default getAccount;
